import React, { PureComponent } from "react";
import { Button, CardBody, Col, Row } from "reactstrap";
import "./FileDropzone.scss";
import { ActionsRow, commons, Icon, Loader } from "@mc/mc-legacy";
import { Checkbox } from "@mc/ui-v3";
const { sinkEvent } = commons;
/**
 * List item pro soubor
 */

export default class FileDropzoneListItem extends PureComponent {
  static propTypes = {};
  static defaultProps = {};
  state = {};
  actions = (file, index) => {
    const disable = file.name.split(".").pop() != "pdf";
    const isLoading = file.loading;
    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="d-flex" onClick={(e)=>e.stopPropagation()} >
        <div className="mt-2 mr-3" >
          <Checkbox
            onClick={() =>sinkEvent( this.props.setAttachment(!file.attachment, index))}
            key={file.uuid}
            disabled={disable}
            defaultChecked={file.attachment}
          >
            {" "}
            Vložit jako přílohu
          </Checkbox>
        </div>
        <div>
          <Button onClick={() =>sinkEvent( this.props.onDeleteFile(file, index))}>
            <Icon icon={"trash"} />
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { file, index } = this.props;
    return (
      <CardBody>
        <ActionsRow actions={this.actions(file, index)}>
          <Row xs={6}>
            <Col onClick={sinkEvent}>
              <span className={"filename-label"}>{file.name}</span>
            </Col>
          </Row>
        </ActionsRow>
      </CardBody>
    );
  }
}
